import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "organization-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-wrap text-truncate" }, "Organizations")
], -1)
const _hoisted_3 = { class: "dt-container" }
const _hoisted_4 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "No Organizations found", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "inventory-table__actions d-sm-flex align-items-end my-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      ((!_ctx.loading && !_ctx.orgSearchResults))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_input, {
                placeholder: "Search Organizations",
                modelValue: _ctx.orgSearch,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orgSearch) = $event)),
                onKeyup: _ctx.handleSearchChange
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _createVNode(_component_el_table, {
              data: _ctx.orgSearchResults,
              ref: "organizationsTable",
              onRowDblclick: _ctx.handleCurrentChange,
              onSortChange: _ctx.handleSortChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Name",
                  sortable: "custom"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_router_link, {
                      to: `/admin/organizations/${scope.row.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "billing.billing_type",
                  label: "Billing Type",
                  sortable: "custom"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "billing.subscription_limit",
                  label: "Subscription Count",
                  sortable: "custom"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "billing.expiration_date",
                  label: "Exp Date",
                  sortable: "custom"
                })
              ]),
              _: 1
            }, 8, ["data", "onRowDblclick", "onSortChange"]),
            _hoisted_8,
            _createVNode(_component_el_pagination, {
              class: "d-flex justify-content-center",
              background: "",
              layout: "prev, pager, next",
              total: _ctx.orgCount,
              onCurrentChange: _ctx.handleCurrentPageChange,
              "current-page": _ctx.currentPage,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event))
            }, null, 8, ["total", "onCurrentChange", "current-page"])
          ], 64))
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}